import { isValidComponentSize } from '../../../../utils/validators';
import type { PropType } from 'vue';
import type { Options } from '@popperjs/core';
export const defaultProps = {
    name: {
        type: [Array, String],
        default: '',
    },
    popperClass: {
        type: String,
        default: '',
    },
    format: {
        type: String,
    },
    valueFormat: {
        type: String as PropType<string>,
    },
    type: {
        type: String,
        default: '',
    },
    clearable: {
        type: Boolean,
        default: true,
    },
    clearIcon: {
        type: String,
        default: 'pt-icon-circle-close',
    },
    editable: {
        type: Boolean,
        default: true,
    },
    prefixIcon: {
        type: String,
        default: '',
    },
    size: {
        type: String as PropType<ComponentSize>,
        validator: isValidComponentSize,
    },
    readonly: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    placeholder: {
        type: String,
        default: '',
    },
    popperOptions: {
        type: Object as PropType<Options>,
        default: () => ({}),
    },
    modelValue: {
        type: [Date, Array, String] as PropType<string | Date | Date[]>,
        default: '',
    },
    rangeSeparator: {
        type: String,
        default: '-',
    },
    startPlaceholder: String,
    endPlaceholder: String,
    defaultValue: {
        type: [Date, Array] as PropType<Date | Date[]>,
    },
    defaultTime: {
        type: [Date, Array] as PropType<Date | Date[]>,
    },
    isRange: {
        type: Boolean,
        default: false,
    },
    disabledHours: {
        type: Function,
    },
    disabledMinutes: {
        type: Function,
    },
    disabledSeconds: {
        type: Function,
    },
    disabledDate: {
        type: Function,
    },
    cellClassName: {
        type: Function,
    },
    shortcuts: {
        type: Array,
        default: () => [],
    },
    defaultShortcut: {
        type: Object
    },
    arrowControl: {
        type: Boolean,
        default: false,
    },
    validateEvent: {
        type: Boolean,
        default: true,
    },
    unlinkPanels: Boolean,
    timeZone: {
        type: String
    }
};
